export enum ImageOrientation {
	Landscape = 'Landscape',
	Portrait = 'Portrait',
}
